module.exports = __webpack_public_path__ + "static/media/SharpSansNo1-Semibold.e2f1e644.ttf";